import { useState } from 'react';

const faqs = [
  {
    q: '瓜子影视APP下载官网是哪一个？',
    a: '本站即为瓜子影视官方推广站，提供了瓜子影视APP下载官网入口。点击页面上方的「下载瓜子影视」按钮进入下载页，即可选择对应平台获取安装包。',
  },
  {
    q: '瓜子影视iOS官网最新下载安装怎么操作？',
    a: '在下载页选择 iOS 平台，按照页面提示完成瓜子影视iOS官网最新下载安装即可。安装前请先在系统设置中信任对应描述文件。',
  },
  {
    q: '瓜子影视TV版2026官方最新版下载支持哪些设备？',
    a: '瓜子影视TV版2026官方最新版下载支持主流智能电视与电视盒子。安装到电视后可与手机端登录同一账号，观看进度自动同步。',
  },
  {
    q: '瓜子影视支持哪些系统？',
    a: '目前瓜子影视提供 Android、iOS、HarmonyOS 与 TV版 四种版本，覆盖手机、平板、鸿蒙设备以及电视大屏，满足不同场景的观影需求。',
  },
  {
    q: '下载后无法安装怎么办？',
    a: '请确认已通过瓜子影视APP下载官网获取安装包，并允许设备安装来自受信任来源的应用。若仍无法安装，请参考左侧下载前小贴士逐项排查。',
  },
];

const tips = [
  '认准官方域名 guaziyingshi.net，只在官网获取瓜子影视安装包。',
  '安卓手机安装前，请在系统设置中开启「允许安装未知来源应用」。',
  '电视端安装，建议先将安装包拷贝到 U 盘，再通过电视文件管理器安装。',
];

export default function GuaziFaq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="guazi-anchor w-full bg-background-50 pt-20 md:pt-28 pb-16 md:pb-24 px-4 md:px-6">
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-14">
        {/* 左侧说明 + 下载前小贴士 */}
        <div className="lg:col-span-2 lg:sticky lg:top-28 self-start">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 bg-secondary-100 text-secondary-700 rounded-full text-xs md:text-sm font-bold">
            <i className="ri-question-line text-base" />
            常见问题
          </span>
          <h2 className="mt-4 font-heading font-extrabold text-3xl md:text-4xl text-foreground-950 leading-tight">
            关于瓜子影视，你想知道的都在这
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-7">
            下载、安装、支持系统……常见疑问已为你整理好，按序号点开即可查看答案。
          </p>

          <div className="mt-7 rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
            <div className="flex items-center gap-3">
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700 shrink-0">
                <i className="ri-lightbulb-flash-line text-xl" />
              </span>
              <div>
                <p className="font-heading font-bold text-base text-foreground-950">下载前小贴士</p>
                <p className="text-xs text-foreground-500 mt-0.5">做好这三步，安装更顺利</p>
              </div>
            </div>
            <ul className="mt-5 flex flex-col gap-3.5">
              {tips.map((tip, index) => (
                <li key={tip} className="flex items-start gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 shrink-0 text-xs font-bold">
                    {index + 1}
                  </span>
                  <span className="text-sm text-foreground-700 leading-6">{tip}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* 右侧问题列表 */}
        <div className="lg:col-span-3 flex flex-col gap-3 md:gap-4">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.q}
                className={`rounded-lg border overflow-hidden transition-colors duration-200 ${
                  isOpen ? 'bg-background-100 border-primary-300' : 'bg-background-100 border-background-200 hover:border-primary-200'
                }`}
              >
                <button
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  className="w-full flex items-center gap-4 px-5 py-4 md:px-6 md:py-5 text-left cursor-pointer"
                >
                  <span className={`w-8 h-8 flex items-center justify-center rounded-full shrink-0 font-heading font-bold text-sm ${
                    isOpen ? 'bg-primary-500 text-primary-950' : 'bg-background-200 text-foreground-700'
                  }`}>
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <span className="flex-1 font-heading font-bold text-base md:text-lg text-foreground-950">{item.q}</span>
                  <span className="shrink-0 text-foreground-500" style={{ width: '20px', height: '20px' }}>
                    <i className={isOpen ? 'ri-arrow-up-s-line text-xl' : 'ri-arrow-down-s-line text-xl'} />
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 md:px-6 md:pb-6 pl-[68px] md:pl-[72px]">
                    <p className="text-sm text-foreground-600 leading-7">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}